import { Text } from '@contentful/rich-text-types'
import { Document } from '@contentful/rich-text-types'
import { Card } from '~/components/main-page/Instruments/Card'
import { getContentfulAsset } from '~/libs/contentful/helpers'
import { TypeBlockWith3CardLinks } from '~/types/contentful'

type InstrumentsProps = {
  section: TypeBlockWith3CardLinks<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export type AssetData = {
  title: string
  image: {
    alt: string
    url: string
  }
  video?: string
  link: string
}

export const Instruments = ({ section }: InstrumentsProps) => {
  const getTitle = (title: Document) => {
    if (!title) return ''

    return title?.content[0].content.reduce((acc: string, item) => {
      if (item.nodeType === 'text') {
        acc += item.value
      }
      if (item.nodeType === 'hyperlink') {
        acc += `<span>${(item?.content[0] as Text).value}</span>`
      }
      return acc
    }, '')
  }

  const fields = section.fields

  const firstTitle = getTitle(fields.dynamicalTitle as Document)
  const secondTitle = getTitle(fields.secondDynamicalTitle as Document)
  const thirdTitle = getTitle(fields.thirdDynamicalTitle as Document)

  const firstImage = getContentfulAsset(fields.firstImage)
  const secondImage = getContentfulAsset(fields.secondImage)
  const thirdImage = getContentfulAsset(fields.thirdImage)

  const firstMedia = getContentfulAsset(fields.firstMedia)
  const secondMedia = getContentfulAsset(fields.secondMedia)
  const thirdMedia = getContentfulAsset(fields.thirdMedia)

  const data = [
    {
      title: firstTitle,
      image: {
        alt: firstImage?.fields.title,
        url: firstImage?.fields.file?.url,
      },
      video: firstMedia?.fields.file?.url,
      link: fields.firstLink,
    },
    {
      title: secondTitle,
      image: {
        alt: secondImage?.fields.title,
        url: secondImage?.fields.file?.url,
      },
      video: secondMedia?.fields.file?.url,
      link: fields.secondLink,
      labelText: fields.secondLabelText,
      description: fields.secondDescriptionText,
    },
    {
      title: thirdTitle,
      image: {
        alt: thirdImage?.fields.title,
        url: thirdImage?.fields.file?.url,
      },
      video: thirdMedia?.fields.file?.url,
      link: fields.thirdLink,
    },
  ] as AssetData[]

  return (
    <>
      <section
        className="mx-0 my-25 max-lg:my-15 max-md:mt-20"
        data-block-id={section.fields.blockId}
      >
        <div className="max-xl:grid-cols-3 max-lg:grid-cols-2 max-md:grid-cols-1 text-2xl grid items-start gap-8 my-0 mx-auto max-w-[1120px] grid-cols-[1.05fr_0.5fr_0.5fr]">
          {data.map((item, index) => (
            <Card item={item} key={index} />
          ))}
        </div>
      </section>
    </>
  )
}
